import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Weddingcarrentalmumbai() {



  const cardData =
  {
    keyword: 'Wedding Car Rental Mumbai ',
    heading: 'Shambhu Cabs: Wedding Car Rental Mumbai',
    headingDescription: 'Shambhu Cabs offers premium Wedding Car Rental services in Mumbai, providing safe, elegant, and hassle-free transportation for brides, grooms, families, and wedding guests. Our fleet of luxury sedans, SUVs, and premium cars ensures a stylish and comfortable journey, making your special day truly memorable. With professional chauffeurs, flexible hourly and full-day rental options, and 24/7 booking support, Shambhu Cabs makes wedding travel convenient, punctual, and stress-free. From South Mumbai to Thane, Andheri to Navi Mumbai, Shambhu Cabs provides doorstep pickup and trusted wedding car rental services in Mumbai for travelers seeking luxury, safety, and a seamless wedding experience.',

    top: 'Top Places to Visit in Mumbai with Shambhu Cabs',

 
"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "The Gateway of India, built in 1924 to commemorate the visit of King George V and Queen Mary, is one of Mumbai’s most iconic landmarks. Located on the waterfront in Colaba, it features grand arches in Indo-Saracenic style, offering panoramic views of the Arabian Sea. The surrounding area is lively with street vendors, boat rides to Elephanta Island, and cultural performances, making it a must-visit for tourists exploring Mumbai’s heritage and coastal beauty."
  },
  {
    "title": "Marine Drive",
    "description": "Marine Drive, also known as the Queen’s Necklace, is a 3.6 km long boulevard along the Arabian Sea. Famous for its Art Deco buildings and stunning sunset views, it attracts joggers, families, and tourists. The promenade lights up at night, giving it the appearance of a string of pearls. Marine Drive is perfect for leisurely walks, photography, and experiencing Mumbai’s vibrant coastal life."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
    "description": "CSMT, formerly Victoria Terminus, is a UNESCO World Heritage Site and one of India’s busiest railway stations. Built in 1887 in Victorian Gothic style with domes, turrets, and intricate stone carvings, it is an architectural marvel. The station symbolizes Mumbai’s colonial past and modern connectivity, serving as both a transportation hub and a tourist attraction admired for its historical and cultural significance."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "Siddhivinayak Temple, dedicated to Lord Ganesha, is one of Mumbai’s most revered religious sites. Located in Prabhadevi, it attracts thousands of devotees daily who seek blessings and fulfillment of wishes. The temple’s idol, adorned with gold, intricate carvings, and beautiful decorations, creates a spiritual and serene atmosphere. Festivals, especially Ganesh Chaturthi, see grand celebrations, making it a cultural and religious landmark."
  },
  {
    "title": "Elephanta Caves",
    "description": "Elephanta Caves, located on Elephanta Island near Mumbai, are UNESCO World Heritage Sites featuring rock-cut sculptures dedicated to Lord Shiva. Dating back to the 5th-8th centuries, the caves showcase intricate carvings such as the Trimurti statue, depicting the Hindu trinity. Visitors reach the island by ferry from the Gateway of India, making it a historical, cultural, and scenic destination combining art, mythology, and maritime beauty."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah is a mosque and tomb situated on an islet off the coast of Worli, accessible via a narrow causeway. Dedicated to Sufi saint Pir Haji Ali Shah Bukhari, it attracts pilgrims and tourists from around the world. The white marble structure, set against the Arabian Sea, is especially picturesque during high tide and sunset. It is a symbol of Mumbai’s religious harmony and spiritual heritage."
  },
  {
    "title": "Chor Bazaar",
    "description": "Chor Bazaar, meaning 'Thieves Market,' is one of Mumbai’s oldest and largest flea markets, famous for antiques, vintage items, Bollywood memorabilia, and curiosities. The bustling market is a treasure trove for collectors, photographers, and bargain hunters. Strolling through its narrow lanes, visitors experience the vibrant chaos, history, and culture of Mumbai’s trading legacy, making it a must-visit for shoppers seeking unique finds."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is one of Mumbai’s most popular beaches, known for its vibrant street food, sunset views, and lively atmosphere. Locals and tourists flock here to enjoy snacks like pav bhaji, bhel puri, and ice cream while walking along the shore. The beach is also home to cultural events, kite flying, and recreational activities, offering a relaxing escape from the bustling city life and a perfect spot for family outings and photography."
  },
  {
    "title": "Mount Mary Church",
    "description": "Mount Mary Basilica, located in Bandra, is a Roman Catholic church renowned for its serene ambiance, beautiful architecture, and annual Bandra Fair. The church attracts pilgrims and tourists alike, offering stunning views of the surrounding hills and sea. Its blend of Gothic and modern architecture, along with the spiritual atmosphere, makes it a must-visit destination for those exploring Mumbai’s religious and cultural heritage."
  },
  {
    "title": "Sanjay Gandhi National Park",
    "description": "Sanjay Gandhi National Park, located in the northern suburbs of Mumbai, is a lush green sanctuary spanning over 100 square kilometers. It houses diverse flora and fauna, including leopards, deer, and various bird species. The park features the Kanheri Caves, trekking trails, boating, and safari options. It serves as a natural escape from the urban hustle, offering wildlife encounters, historical exploration, and outdoor adventure for families and nature enthusiasts."
  }
],




"services": [
  {
    "name": "Wedding Luxury Car Mumbai",
    "description": "Wedding Luxury Car Mumbai provides premium, stylish vehicles for weddings and special occasions in Mumbai. The service includes well-maintained luxury sedans, SUVs, and limousines with professional chauffeurs to ensure a smooth and elegant ride. Ideal for the bride and groom, family members, or VIP guests, the service also offers customizable decorations, timely pickups, and hassle-free booking for a truly memorable wedding experience."
  },
  {
    "name": "Bridal Car Rental Mumbai",
    "description": "Bridal Car Rental Mumbai specializes in providing elegantly decorated cars for brides on their special day. The service offers a variety of luxury sedans, SUVs, and vintage cars, with professional drivers trained to provide a safe, comfortable, and stylish journey. Flexible booking options, on-time pickups, and attention to wedding-themed details make this service perfect for creating a grand entrance."
  },
  {
    "name": "Wedding SUV Rental Mumbai",
    "description": "Wedding SUV Rental Mumbai offers spacious and luxurious SUVs for wedding events, ideal for family transport or group travel. With experienced chauffeurs, well-maintained vehicles, and decorative options, this service ensures comfort, style, and safety for guests attending weddings. The service is suitable for both local weddings and long-distance travel."
  },
  {
    "name": "Premium Wedding Car Hire Mumbai",
    "description": "Premium Wedding Car Hire Mumbai provides high-end vehicles for weddings, including Mercedes, BMW, Audi, and other luxury brands. The service ensures well-groomed chauffeurs, fully maintained cars, and personalized decoration options. Perfect for couples seeking a lavish wedding experience, corporate clients, or VIP guests, the service guarantees punctuality, elegance, and complete peace of mind."
  },
  {
    "name": "Vintage Wedding Car Mumbai",
    "description": "Vintage Wedding Car Mumbai offers classic and retro cars for weddings, perfect for adding a touch of nostalgia and elegance. The service includes chauffeur-driven antique cars, decorative options, and flexible packages for both city and outstation weddings. Ideal for couples looking for a unique and memorable wedding arrival or photo shoot experience."
  },
  {
    "name": "Wedding Sedan Rental Mumbai",
    "description": "Wedding Sedan Rental Mumbai provides luxury and comfortable sedans for wedding occasions, ensuring style and elegance for the bride, groom, and family members. Vehicles are clean, well-maintained, and available with professional chauffeurs. The service offers timely pickups, flexible packages, and customizable decorations for a complete wedding transportation solution."
  },
  {
    "name": "Wedding Chauffeur Car Mumbai",
    "description": "Wedding Chauffeur Car Mumbai offers professional drivers along with luxury vehicles to provide a stress-free wedding transportation experience. Chauffeurs are trained to handle wedding itineraries efficiently, ensuring smooth and safe rides for the couple, guests, and family members. The service also provides on-demand decorative options for added glamour."
  },
  {
    "name": "Marriage Car Rental Mumbai",
    "description": "Marriage Car Rental Mumbai provides a wide range of vehicles for wedding ceremonies, including luxury cars, SUVs, and limousines. The service ensures professional chauffeurs, punctual pickups, and stylish decoration options. Suitable for both the bride and groom, as well as guest transportation, this service offers convenience, safety, and elegance for the entire wedding day."
  },
  {
    "name": "Wedding Decorated Cars Mumbai",
    "description": "Wedding Decorated Cars Mumbai specializes in providing fully decorated vehicles for weddings, including floral arrangements, ribbons, and customized themes. The service includes luxury cars, SUVs, and vintage options with professional chauffeurs to ensure a comfortable and stylish ride. Perfect for creating a memorable wedding entry and photography experience."
  },
  {
    "name": "Affordable Wedding Car Rental",
    "description": "Affordable Wedding Car Rental offers budget-friendly options for wedding transportation without compromising on style or comfort. The service provides well-maintained cars, SUVs, and sedans with professional chauffeurs, flexible packages, and decorative options suitable for small weddings, family events, and guest transfers."
  },
  {
    "name": "Wedding Limousine Mumbai",
    "description": "Wedding Limousine Mumbai provides luxurious stretch limousines for a grand wedding entrance. The service includes professional chauffeurs, elegant decoration options, and spacious interiors for couples and their entourage. Perfect for VIP weddings, high-profile events, or glamorous pre-wedding celebrations."
  },
  {
    "name": "Wedding Event Transport Mumbai",
    "description": "Wedding Event Transport Mumbai ensures reliable and stylish transportation for all wedding-related events, including mehendi, sangeet, and reception. The service offers a variety of luxury cars, SUVs, and limousines with professional chauffeurs, timely pickups, and customized decoration options to enhance the overall wedding experience."
  },
  {
    "name": "Pre-Wedding Car Rental Mumbai",
    "description": "Pre-Wedding Car Rental Mumbai provides elegant and luxury vehicles for pre-wedding events, photoshoots, and functions. The service includes well-maintained cars, SUVs, and vintage vehicles with professional drivers. Flexible packages, decorative options, and on-time service make it ideal for creating memorable pre-wedding moments."
  },
  {
    "name": "Wedding Mercedes Rental Mumbai",
    "description": "Wedding Mercedes Rental Mumbai specializes in providing luxury Mercedes vehicles for weddings. The service includes professional chauffeurs, decorative options, and flexible packages. Perfect for couples seeking a high-end wedding experience, VIP guest transfers, or stylish pre-wedding and post-wedding transportation."
  },
  {
    "name": "Wedding Audi BMW Rental",
    "description": "Wedding Audi BMW Rental offers premium Audi and BMW cars for weddings, ensuring comfort, style, and elegance. The service provides professional drivers, decorative customization, and reliable scheduling for both local and outstation weddings. Ideal for high-profile weddings and couples looking for luxury transportation."
  },
  {
    "name": "Wedding Guest Transportation Mumbai",
    "description": "Wedding Guest Transportation Mumbai provides efficient and comfortable transport for wedding guests, including luxury cars, SUVs, and vans. The service ensures timely pickups, professional chauffeurs, and well-maintained vehicles, making it easier for guests to reach venues and enjoy a hassle-free wedding experience."
  },
  {
    "name": "24×7 Wedding Car Rental Mumbai",
    "description": "24×7 Wedding Car Rental Mumbai offers round-the-clock availability for wedding transportation needs. From last-minute bookings to pre-scheduled rides, the service provides luxury cars, SUVs, and limousines with professional chauffeurs, timely pickups, and decoration options for all wedding events."
  }
],

"tableData": [
  ["Wedding Luxury Car Mumbai", "Bridal Car Rental Mumbai"],
  ["Wedding SUV Rental Mumbai", "Premium Wedding Car Hire Mumbai"],
  ["Vintage Wedding Car Mumbai", "Wedding Sedan Rental Mumbai"],
  ["Wedding Chauffeur Car Mumbai", "Marriage Car Rental Mumbai"],
  ["Wedding Decorated Cars Mumbai", "Affordable Wedding Car Rental"],
  ["Wedding Limousine Mumbai", "Wedding Event Transport Mumbai"],
  ["Pre-Wedding Car Rental Mumbai", "Wedding Mercedes Rental Mumbai"],
  ["Wedding Audi BMW Rental", "Wedding Guest Transportation Mumbai"],
  ["24×7 Wedding Car Rental Mumbai", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Wedding Car Rental in Mumbai with Shambhu Cabs",
    "WhyChoosedescription": "Shambhu Cabs offers premium wedding car rental services in Mumbai, perfect for weddings, receptions, and special occasions with style and comfort."
  },
  {
    "WhyChooseheading": "Luxurious and Well-Maintained Vehicles",
    "WhyChoosedescription": "Choose from a fleet of elegant, air-conditioned, and meticulously maintained cars to make your wedding day truly memorable."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Special Occasions",
    "WhyChoosedescription": "Our professional drivers are experienced in handling wedding routes and events, ensuring timely and safe arrivals for your celebrations."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "We provide clear, upfront pricing—fuel, tolls, and driver allowances included—so your wedding car rental is hassle-free and budget-friendly."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings, event planning, and travel arrangements for your wedding day."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans for Weddings",
    "WhyChoosedescription": "Choose from hourly, half-day, full-day, or customized rental plans tailored to your wedding schedule and requirements."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All wedding cars are thoroughly cleaned and sanitized to ensure a safe, hygienic, and luxurious travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making your wedding day travel smooth, stylish, and worry-free."
  }
]




















  }

const faqData = [
  {
    question: 'Does Shambhu Cabs provide wedding car rental services in Mumbai?',
    answer: 'Yes, Shambhu Cabs offers premium wedding car rental services in Mumbai, providing elegant and well-maintained vehicles for your special day.',
  },
  {
    question: 'How can I book a wedding car in Mumbai with Shambhu Cabs?',
    answer: 'You can book easily through our website, mobile app, or by contacting our 24x7 customer support team to select your preferred wedding car.',
  },
  {
    question: 'What types of vehicles are available for wedding car rentals in Mumbai?',
    answer: 'Shambhu Cabs offers luxury sedans, SUVs, and premium cars suitable for weddings, receptions, and other special occasions.',
  },
  {
    question: 'Are drivers experienced for wedding car rentals in Mumbai?',
    answer: 'Yes, our drivers are professional, well-trained, and courteous to ensure a smooth and elegant ride on your wedding day.',
  },
  {
    question: 'Can I choose custom pickup and drop-off locations for wedding car rentals in Mumbai?',
    answer: 'Absolutely. You can choose your preferred pickup and drop-off points to suit your wedding itinerary and schedule.',
  },
  {
    question: 'Is wedding car rental service available 24x7 in Mumbai?',
    answer: 'Yes, Shambhu Cabs provides round-the-clock wedding car rental services to accommodate any wedding schedule.',
  },
  {
    question: 'Are safety and hygiene protocols followed for wedding car rentals in Mumbai?',
    answer: 'All vehicles are thoroughly cleaned and sanitized, and our drivers follow strict hygiene and safety protocols for your peace of mind.',
  },
  {
    question: 'What payment options are available for wedding car rentals in Mumbai?',
    answer: 'We accept UPI, digital wallets, credit/debit cards, bank transfers, and corporate payments for wedding car bookings.',
  },
  {
    question: 'Is customer support available during wedding car service in Mumbai?',
    answer: 'Yes, our 24x7 customer support team is available to assist you throughout your wedding car service in Mumbai.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Arjun Mehta',
    feedback: 'Shambhu Cabs made our wedding day extra special. The car was beautiful, and the driver was very professional.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Sneha Kapoor',
    feedback: 'Highly recommend Shambhu Cabs for wedding car rentals in Mumbai. Excellent service and luxury vehicles for a perfect day!',
    rating: 5,
  },
];




















































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "mumbai-outstation-cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "mumbai-to-mahabaleshwar-cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "mumbai-to-goa-cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "mumbai-to-shirdi-cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "mumbai-nashik-cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "mumbai-to-kolhapur-cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "mumbai-to-pune-cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "mumbai-to-aurangabad-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "mumbai-to-bhimashankar-cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "mumbai-to-ashtavinayak-cab-service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "mumbai-to-5-jyotirlinga-cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "mumbai-to-lonavala-cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "mumbai-to-konkan-darshan-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "mumbai-to-alibaug-cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "mumbai-to-ahmednagar-cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "mumbai-to-matheran-cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon / Dhule Cab", link: "mumbai-to-jalgaon-dhule-cab" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "mumbai-to-lavasa-cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "mumbai-to-panchgani-cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "mumbai-to-khandala-taxi-fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "mumbai-to-surat-cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "mumbai-to-ahmedabad-cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "mumbai-to-narmada-parikrama-cab-booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Vadodara Cab", link: "mumbai-to-vadodara-cab" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "mumbai-to-daman-taxi" },
  ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Wedding Car Rental Mumbai",
  "image": "https://www.shambhucab.com/assets/images/wedding-car-rental-mumbai.jpg",
  "description": "Shambhu Cabs offers premium wedding car rental services in Mumbai. Rent luxury, vintage, SUV, or sedan cars for weddings, pre-wedding shoots, bridal rides, and guest transportation. Available 24×7 with chauffeur-driven service, decorated cars, and affordable packages for a memorable wedding experience.",
  "brand": {
    "@type": "Brand",
    "name": "Shambhu Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5300",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "5000",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shambhucab.com/wedding-car-rental-mumbai"
  }
};




  return (
    <div>
<Helmet>
  <title>Wedding Car Rental Mumbai | Luxury & Premium Cars | Shambhu Cabs</title>

  <meta
    name="description"
    content="Book wedding car rental in Mumbai with Shambhu Cabs. Luxury, vintage, SUV, and sedan cars available for weddings, bridal rides, pre-wedding shoots, and guest transport. 24×7 chauffeur-driven service with decorated cars and affordable packages."
  />

  <meta
    name="keywords"
    content="Wedding Luxury Car Mumbai, Bridal Car Rental Mumbai, Wedding SUV Rental Mumbai, Premium Wedding Car Hire Mumbai, Vintage Wedding Car Mumbai, Wedding Sedan Rental Mumbai, Wedding Chauffeur Car Mumbai, Marriage Car Rental Mumbai, Wedding Decorated Cars Mumbai, Affordable Wedding Car Rental, Wedding Limousine Mumbai, Wedding Event Transport Mumbai, Pre-Wedding Car Rental Mumbai, Wedding Mercedes Rental Mumbai, Wedding Audi BMW Rental, Wedding Guest Transportation Mumbai, 24×7 Wedding Car Rental Mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <section className="gauto-breadcromb-area section_70">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcromb-box">
                <h3> {cardData.keyword}</h3>
              </div>
            </div>
          </div>
        </div>
      </section>







      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/33.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

            

              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shambhu Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shambhu Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919819399797" className="pc-call">+91 9819399797</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919819399797"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919819399797" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shambhucab.com" className="pc-email">
                      booking@shambhucab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shambhu Cabs</strong><br />
                      Saket Tata Power CHS, Swami Samarth Marg,
                      Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                      Maharashtra India - 400703
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Weddingcarrentalmumbai;